export enum EChatType {
    DefaultChat = 'Chat',
    Channel = 'Channel',
    Order = 'Order',
    Action = 'Action',
    CustomerService = 'CustomerService',
}
